import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import ModalSuppliers from '../../ModalSuppliers/ModalSuppliers';
import {
  deleteSupplier,
  findDuplicateSupplier,
  loadSupplierById,
  saveSupplier,
} from '../../../core/utils/supplier';
import { validateEmail } from '../../../core/utils/string';
import { sanitizeCnpj, isValidCnpj } from '../../../core/utils/cnpj';
import { alertError, alertSuccess } from '../../../components/Toast';

const INITIAL = { status: 'ativo' };

// Reaproveita o form apresentacional de fornecedor (ModalSuppliers) dentro de um
// react-modal, para permitir cadastrar/editar fornecedor direto do lançamento
// financeiro (mesmo comportamento do botão de cliente no orçamento). Devolve o
// fornecedor salvo em onSaved para o chamador já selecioná-lo.
const SupplierFormModal = ({
  isOpen,
  supplierId,
  companyId,
  userId,
  onClose,
  onSaved,
}) => {
  const [values, setValues] = useState(INITIAL);
  const isNew = !supplierId;

  useEffect(() => {
    if (!isOpen) return;
    if (supplierId) {
      loadSupplierById(supplierId).then((s) => {
        if (s) setValues({ ...s });
      });
    } else {
      setValues(INITIAL);
    }
  }, [isOpen, supplierId]);

  const onChange = (field, value) =>
    setValues((v) => ({ ...v, [field]: value }));

  const onSave = async () => {
    const supplier = { ...values };

    if (!supplier.name || !supplier.name.trim()) {
      alertError('Nome é obrigatório');
      return;
    }
    if (supplier.email && !validateEmail(supplier.email)) {
      alertError('E-mail inválido');
      return;
    }

    if (
      sanitizeCnpj(supplier.cpf_cnpj).length === 14 &&
      !isValidCnpj(supplier.cpf_cnpj)
    ) {
      alertError('CNPJ inválido');
      return;
    }

    const isDuplicate = await findDuplicateSupplier(
      companyId,
      supplier.name,
      supplier.cpf_cnpj,
      supplier.id
    );
    if (isDuplicate) {
      alertError('Já existe um fornecedor com este nome/documento.');
      return;
    }

    const payload = {
      name: supplier.name.trim(),
      cpf_cnpj: supplier.cpf_cnpj || null,
      email: supplier.email || null,
      phone: supplier.phone || null,
      observation: supplier.observation || null,
      status: supplier.status || 'ativo',
      company_id: companyId,
    };
    const { data, error } = await saveSupplier(supplier.id, payload, userId);
    if (error) {
      alertError('Erro ao salvar o fornecedor, tente novamente mais tarde.');
      return;
    }

    alertSuccess('Fornecedor salvo!');
    // INSERT retorna o registro novo; UPDATE não retorna — reconstrói do state.
    const saved = data?.[0] || { id: supplier.id, ...payload };
    if (onSaved) onSaved(saved);
    if (onClose) onClose();
  };

  const onRemove = async () => {
    if (!values.id) {
      if (onClose) onClose();
      return;
    }
    const { error } = await deleteSupplier(values.id, userId);
    if (error) {
      alertError('Erro ao remover o fornecedor.');
      return;
    }
    alertSuccess('Fornecedor removido!');
    if (onSaved) onSaved(null);
    if (onClose) onClose();
  };

  if (!isOpen) return null;

  return (
    <Modal
      onRequestClose={onClose}
      className={'prospera-modal'}
      isOpen={isOpen}
    >
      <ModalSuppliers
        values={values}
        onChange={onChange}
        onSave={onSave}
        closeModal={onClose}
        isNew={isNew}
        compareValues={true}
        onRemove={onRemove}
      />
    </Modal>
  );
};

export default SupplierFormModal;
